import { __decorate, __metadata } from "tslib";
import { IsNotEmptyObjectWithLVS } from '@goparrot/common';
import { Expose, Type } from 'class-transformer';
import { IsEnum, IsNotEmpty, IsOptional, IsString, ValidateNested } from 'class-validator';
import { EarnRuleTypeEnum, LoyaltyProgramExposeGroupEnum, TimeframeTypeEnum } from '../interface';
import { CreateAbstractTimeframeDto } from './CreateAbstractTimeframeDto';
import { CreateTimeframeDefaultDto } from './CreateTimeframeDefaultDto';
import { CreateTimeframeSpecificDto } from './CreateTimeframeSpecificDto';
import { CreateTimeframeWeeklyDto } from './CreateTimeframeWeeklyDto';
export class CreateAbstractEarnRuleDto {
}
__decorate([
    Expose({ groups: [LoyaltyProgramExposeGroupEnum.READ, LoyaltyProgramExposeGroupEnum.PUT, LoyaltyProgramExposeGroupEnum.CREATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], CreateAbstractEarnRuleDto.prototype, "uuid", void 0);
__decorate([
    Expose({ groups: [LoyaltyProgramExposeGroupEnum.READ, LoyaltyProgramExposeGroupEnum.PUT, LoyaltyProgramExposeGroupEnum.CREATE] }),
    IsNotEmpty({ always: true }),
    IsEnum(EarnRuleTypeEnum, { always: true }),
    __metadata("design:type", String)
], CreateAbstractEarnRuleDto.prototype, "type", void 0);
__decorate([
    Expose({ groups: [LoyaltyProgramExposeGroupEnum.READ, LoyaltyProgramExposeGroupEnum.PUT, LoyaltyProgramExposeGroupEnum.CREATE] }),
    IsOptional({ groups: [LoyaltyProgramExposeGroupEnum.PUT] }),
    IsNotEmptyObjectWithLVS({ always: true }),
    ValidateNested({ always: true }),
    Type(() => CreateAbstractTimeframeDto, {
        discriminator: {
            property: 'type',
            subTypes: [
                { value: CreateTimeframeSpecificDto, name: TimeframeTypeEnum.SPECIFIC },
                { value: CreateTimeframeWeeklyDto, name: TimeframeTypeEnum.WEEKLY },
                { value: CreateTimeframeDefaultDto, name: TimeframeTypeEnum.DEFAULT },
            ],
        },
        keepDiscriminatorProperty: true,
    }),
    __metadata("design:type", Object)
], CreateAbstractEarnRuleDto.prototype, "timeframe", void 0);
//# sourceMappingURL=CreateAbstractEarnRuleDto.js.map